/**
 * H5直播登录
 */
import './uph5/seed';
import './uph5/login';
// import './uph5/share';
// import './deps/datalog';



// WEBPACK FOOTER //
// ./js/component/openjs/h5.js